// extracted by mini-css-extract-plugin
export default {"address":"employeeMaster_address__lVs7N","button":"employeeMaster_button__L5D-w"};